module.exports = __webpack_public_path__ + "static/media/bnmmap.e648a708.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/bnmmap.png
// module id = 751
// module chunks = 0